import { useState } from 'react';
import { ZapIcon, TrendingUpIcon, UsersIcon, SettingsIcon, RocketIcon, HeadphonesIcon, MegaphoneIcon, BriefcaseIcon, BarChart2Icon, CheckSquareIcon, ArrowRightIcon, ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
type SectionKey = 'etapas' | 'metas' | 'areas' | 'pipeline' | 'kpis' | 'prioridades';
const NAV_ITEMS: {
  key: SectionKey;
  label: string;
  icon: React.ReactNode;
}[] = [{
  key: 'etapas',
  label: 'Etapas',
  icon: <TrendingUpIcon size={15} data-id="element-78" />
}, {
  key: 'metas',
  label: 'Metas',
  icon: <ZapIcon size={15} data-id="element-79" />
}, {
  key: 'areas',
  label: 'Áreas',
  icon: <SettingsIcon size={15} data-id="element-80" />
}, {
  key: 'pipeline',
  label: 'Pipeline CRM',
  icon: <ArrowRightIcon size={15} data-id="element-81" />
}, {
  key: 'kpis',
  label: 'KPIs',
  icon: <BarChart2Icon size={15} data-id="element-82" />
}, {
  key: 'prioridades',
  label: 'Prioridades',
  icon: <CheckSquareIcon size={15} data-id="element-83" />
}];
const AREAS = [{
  icon: <MegaphoneIcon size={14} data-id="element-84" />,
  title: 'Marketing',
  lines: ['Contenido · Ads · Branding', 'Venta visual · Automatización'],
  accent: 'border-l-blue-400 bg-blue-50',
  text: 'text-blue-900',
  sub: 'text-blue-500'
}, {
  icon: <BriefcaseIcon size={14} data-id="element-85" />,
  title: 'Ventas',
  lines: ['Llamadas · Seguimiento', 'Cierre · Script · Pipeline'],
  accent: 'border-l-orange-400 bg-orange-50',
  text: 'text-orange-900',
  sub: 'text-orange-500'
}, {
  icon: <SettingsIcon size={14} data-id="element-86" />,
  title: 'Sistema',
  lines: ['GHL · WhatsApp · Pipeline', 'Automatizaciones · Integraciones'],
  accent: 'border-l-gray-400 bg-gray-50',
  text: 'text-gray-800',
  sub: 'text-gray-500'
}, {
  icon: <RocketIcon size={14} data-id="element-87" />,
  title: 'Onboarding',
  lines: ['Bienvenida · Setup', 'Capacitación · Seguimiento'],
  accent: 'border-l-green-400 bg-green-50',
  text: 'text-green-900',
  sub: 'text-green-500'
}, {
  icon: <UsersIcon size={14} data-id="element-88" />,
  title: 'Agentes',
  lines: ['Reclutamiento · Roles', 'Entrenamiento · Evaluación'],
  accent: 'border-l-purple-400 bg-purple-50',
  text: 'text-purple-900',
  sub: 'text-purple-500'
}, {
  icon: <HeadphonesIcon size={14} data-id="element-89" />,
  title: 'Postventa',
  lines: ['Soporte · Seguimiento', 'Renovación · Referidos'],
  accent: 'border-l-pink-400 bg-pink-50',
  text: 'text-pink-900',
  sub: 'text-pink-500'
}];
const PIPELINE = [{
  label: 'Nuevo',
  color: 'bg-blue-100 text-blue-800 border-blue-200'
}, {
  label: 'Contactado',
  color: 'bg-amber-100 text-amber-800 border-amber-200'
}, {
  label: 'Llamada agend.',
  color: 'bg-amber-100 text-amber-800 border-amber-200'
}, {
  label: 'Propuesta env.',
  color: 'bg-purple-100 text-purple-800 border-purple-200'
}, {
  label: 'Cerrado',
  color: 'bg-teal-100 text-teal-800 border-teal-200'
}, {
  label: 'Postventa',
  color: 'bg-green-100 text-green-800 border-green-200'
}];
const KPIS = [{
  title: 'Leads',
  sub: 'generados',
  color: 'text-blue-600',
  bg: 'bg-blue-50 border-blue-100'
}, {
  title: 'Llamadas',
  sub: 'agendadas',
  color: 'text-amber-600',
  bg: 'bg-amber-50 border-amber-100'
}, {
  title: 'Cierres',
  sub: 'mensuales',
  color: 'text-teal-600',
  bg: 'bg-teal-50 border-teal-100'
}, {
  title: 'Tasa cierre',
  sub: '%',
  color: 'text-purple-600',
  bg: 'bg-purple-50 border-purple-100'
}, {
  title: 'T. respuesta',
  sub: 'promedio',
  color: 'text-orange-600',
  bg: 'bg-orange-50 border-orange-100'
}, {
  title: 'Agentes',
  sub: 'incorporados',
  color: 'text-green-600',
  bg: 'bg-green-50 border-green-100'
}];
const PRIORIDADES = ['Definir oferta principal', 'Crear pipeline en GHL', 'Activar conexión con WhatsApp', 'Crear guion de llamada', 'Organizar base de contactos', 'Definir propuesta visual', 'Diseñar sistema de seguimiento', 'Definir onboarding inicial', 'Crear estructura de automatización', 'Definir KPIs del mes'];
function Section({
  title,
  children,
  open,
  onToggle
}: {
  title: string;
  children: React.ReactNode;
  open: boolean;
  onToggle: () => void;
}) {
  return <div className="border border-gray-100 rounded-xl overflow-hidden mb-3" data-id="element-90">
      <button onClick={onToggle} className="w-full flex items-center justify-between px-4 py-3 bg-white hover:bg-gray-50 transition-colors" data-id="element-91">
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest" data-id="element-92">{title}</span>
        {open ? <ChevronDownIcon size={14} className="text-gray-400" data-id="element-93" /> : <ChevronRightIcon size={14} className="text-gray-400" data-id="element-94" />}
      </button>
      {open && <div className="px-4 pb-4 pt-1 bg-white" data-id="element-95">{children}</div>}
    </div>;
}
export function GodDigitalSystem() {
  const [active, setActive] = useState<SectionKey>('etapas');
  const [open, setOpen] = useState<Record<SectionKey, boolean>>({
    etapas: true,
    metas: true,
    areas: true,
    pipeline: true,
    kpis: true,
    prioridades: true
  });
  const toggle = (k: SectionKey) => setOpen(prev => ({
    ...prev,
    [k]: !prev[k]
  }));
  const scrollTo = (k: SectionKey) => {
    setActive(k);
    setOpen(prev => ({
      ...prev,
      [k]: true
    }));
    setTimeout(() => document.getElementById(`section-${k}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    }), 50);
  };
  return <div className="flex h-screen bg-gray-50 font-sans text-sm overflow-hidden" data-id="element-96">

      {/* SIDEBAR */}
      <aside className="w-52 shrink-0 bg-white border-r border-gray-100 flex flex-col" data-id="element-97">
        {/* Logo */}
        <div className="px-4 py-4 border-b border-gray-100" data-id="element-98">
          <div className="flex items-center gap-2" data-id="element-99">
            <div className="w-7 h-7 rounded-lg bg-purple-600 flex items-center justify-center" data-id="element-100">
              <ZapIcon size={14} className="text-white" data-id="element-101" />
            </div>
            <div data-id="element-102">
              <p className="text-xs font-bold text-gray-900 leading-tight" data-id="element-103">GOD DIGITAL</p>
              <p className="text-[10px] text-gray-400 leading-tight" data-id="element-104">Micro Sistema</p>
            </div>
          </div>
        </div>

        {/* Status badge */}
        <div className="mx-3 mt-3 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200" data-id="element-105">
          <p className="text-[10px] font-semibold text-amber-700 uppercase tracking-wide" data-id="element-106">🟡 Etapa 1 — Activa</p>
          <p className="text-[10px] text-amber-500 mt-0.5" data-id="element-107">Fundación · Multicanal</p>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-2 py-3 space-y-0.5" data-id="element-108">
          {NAV_ITEMS.map(({
          key,
          label,
          icon
        }) => <button key={key} onClick={() => scrollTo(key)} className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs transition-colors ${active === key ? 'bg-purple-50 text-purple-700 font-semibold' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-109">
              {icon}
              {label}
            </button>)}
        </nav>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-100" data-id="element-110">
          <p className="text-[10px] text-gray-300" data-id="element-111">GOD DIGITAL © Etapa 1</p>
        </div>
      </aside>

      {/* MAIN */}
      <main className="flex-1 overflow-y-auto px-6 py-5" data-id="element-112">

        {/* Top bar */}
        <div className="flex items-center justify-between mb-5" data-id="element-113">
          <div data-id="element-114">
            <h1 className="text-base font-bold text-gray-900" data-id="element-115">Dashboard Estratégico</h1>
            <p className="text-xs text-gray-400 mt-0.5" data-id="element-116">Meta: construir base sólida de crecimiento</p>
          </div>
          <div className="flex gap-2" data-id="element-117">
            <span className="text-[10px] px-2.5 py-1 rounded-full bg-gray-100 text-gray-500 border border-gray-200" data-id="element-118">🔴 Etapa 2 — Pendiente</span>
            <span className="text-[10px] px-2.5 py-1 rounded-full bg-gray-100 text-gray-500 border border-gray-200" data-id="element-119">🟢 Etapa 3 — Futura</span>
          </div>
        </div>

        {/* ETAPAS */}
        <div id="section-etapas" data-id="element-120">
          <Section title="Etapas de Crecimiento" open={open.etapas} onToggle={() => toggle('etapas')} data-id="element-121">
            <div className="flex items-center gap-2 mt-1" data-id="element-122">
              {[{
              label: '🟡 Etapa 1 — Activa',
              sub: 'Fundación · Marketing multicanal',
              active: true
            }, {
              label: '🔴 Etapa 2 — Pendiente',
              sub: 'Escala · Onboarding y Agentes',
              active: false
            }, {
              label: '🟢 Etapa 3 — Futura',
              sub: 'Crecimiento · Todas las bases',
              active: false
            }].map((e, i) => <div key={i} className="flex items-center gap-2 flex-1" data-id="element-123">
                  <div className={`flex-1 rounded-lg px-3 py-2.5 border ${e.active ? 'bg-amber-50 border-amber-300' : 'bg-gray-50 border-gray-200'}`} data-id="element-124">
                    <p className={`text-xs font-semibold ${e.active ? 'text-amber-800' : 'text-gray-500'}`} data-id="element-125">{e.label}</p>
                    <p className={`text-[11px] mt-0.5 ${e.active ? 'text-amber-600' : 'text-gray-400'}`} data-id="element-126">{e.sub}</p>
                  </div>
                  {i < 2 && <ArrowRightIcon size={14} className="text-gray-300 shrink-0" data-id="element-127" />}
                </div>)}
            </div>
          </Section>
        </div>

        {/* METAS */}
        <div id="section-metas" data-id="element-128">
          <Section title="3 Metas Centrales" open={open.metas} onToggle={() => toggle('metas')} data-id="element-129">
            <div className="grid grid-cols-3 gap-3 mt-1" data-id="element-130">
              {[{
              n: '01',
              title: 'Generar leads',
              sub: 'Marketing · Ads · Captación',
              color: 'border-l-teal-400'
            }, {
              n: '02',
              title: 'Convertir ventas',
              sub: 'Llamadas · Cierre · Pipeline',
              color: 'border-l-teal-400'
            }, {
              n: '03',
              title: 'Retener y operar',
              sub: 'Postventa · Automatización',
              color: 'border-l-teal-400'
            }].map(m => <div key={m.n} className={`border-l-2 ${m.color} bg-teal-50 border border-teal-100 rounded-r-lg px-3 py-3`} data-id="element-131">
                  <p className="text-[10px] font-bold text-teal-400 mb-1" data-id="element-132">{m.n}</p>
                  <p className="text-xs font-semibold text-teal-900" data-id="element-133">{m.title}</p>
                  <p className="text-[11px] text-teal-600 mt-0.5" data-id="element-134">{m.sub}</p>
                </div>)}
            </div>
          </Section>
        </div>

        {/* ÁREAS */}
        <div id="section-areas" data-id="element-135">
          <Section title="6 Áreas del Sistema" open={open.areas} onToggle={() => toggle('areas')} data-id="element-136">
            <div className="grid grid-cols-3 gap-2.5 mt-1" data-id="element-137">
              {AREAS.map(a => <div key={a.title} className={`border-l-2 border rounded-r-lg px-3 py-3 ${a.accent}`} data-id="element-138">
                  <div className={`flex items-center gap-1.5 mb-1 ${a.text} font-semibold text-xs`} data-id="element-139">
                    {a.icon} {a.title}
                  </div>
                  {a.lines.map(l => <p key={l} className={`text-[11px] ${a.sub}`} data-id="element-140">{l}</p>)}
                </div>)}
            </div>
          </Section>
        </div>

        {/* PIPELINE */}
        <div id="section-pipeline" data-id="element-141">
          <Section title="Pipeline de Ventas — CRM" open={open.pipeline} onToggle={() => toggle('pipeline')} data-id="element-142">
            <div className="flex items-center gap-1.5 mt-2 flex-wrap" data-id="element-143">
              {PIPELINE.map((s, i) => <div key={s.label} className="flex items-center gap-1.5" data-id="element-144">
                  <span className={`border rounded-lg px-3 py-1.5 text-xs font-medium ${s.color}`} data-id="element-145">{s.label}</span>
                  {i < PIPELINE.length - 1 && <ArrowRightIcon size={12} className="text-gray-300" data-id="element-146" />}
                </div>)}
            </div>
          </Section>
        </div>

        {/* KPIs */}
        <div id="section-kpis" data-id="element-147">
          <Section title="KPIs Principales" open={open.kpis} onToggle={() => toggle('kpis')} data-id="element-148">
            <div className="grid grid-cols-6 gap-2 mt-1" data-id="element-149">
              {KPIS.map(k => <div key={k.title} className={`border rounded-xl px-2 py-4 text-center ${k.bg}`} data-id="element-150">
                  <p className={`text-xl font-bold ${k.color}`} data-id="element-151">—</p>
                  <p className="text-[11px] font-semibold text-gray-700 mt-1 leading-tight" data-id="element-152">{k.title}</p>
                  <p className="text-[10px] text-gray-400" data-id="element-153">{k.sub}</p>
                </div>)}
            </div>
          </Section>
        </div>

        {/* PRIORIDADES */}
        <div id="section-prioridades" data-id="element-154">
          <Section title="Prioridades Esta Semana" open={open.prioridades} onToggle={() => toggle('prioridades')} data-id="element-155">
            <div className="grid grid-cols-2 gap-2 mt-1" data-id="element-156">
              {PRIORIDADES.map((p, i) => <div key={p} className="flex items-center gap-2.5 border border-gray-100 bg-gray-50 rounded-lg px-3 py-2.5 hover:bg-white transition-colors cursor-pointer" data-id="element-157">
                  <span className="text-[10px] font-bold text-gray-300 w-4 shrink-0" data-id="element-158">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-xs text-gray-700" data-id="element-159">✦ {p}</span>
                </div>)}
            </div>
          </Section>
        </div>

      </main>
    </div>;
}